import { Box, Grid, Typography } from '@material-ui/core';
import classNames from 'classnames';
import { useConfirm } from 'material-ui-confirm';
import React, { useCallback, useEffect, useState } from 'react';
import UsuarioSemImagem from '../../../../../../../assets/img/usuario-sem-imagem.png';
import { KeyValueModel } from '../../../../../../../model';
import { SngpcStorageKeys, useSngpcStorage, useSessaoAtual, } from '../../../../../../../services/app';
import { useMenuPrincipal } from '../../../../../../../services/app/providers/menu-principal-provider';
import { SelectSaurus } from '../../../../../../components/controles/selects/select-saurus/select-saurus';
import { MenuPrincipalPerfilProps } from './menu-principal-perfil-props';
import { useStyles } from './menu-principal-perfil-styles';

export const MenuPrincipalPerfil = (props: MenuPrincipalPerfilProps) => {
  const classes = useStyles();
  const confirm = useConfirm();
  const { fecharMenu } = useMenuPrincipal();
  const { delRegistro } = useSngpcStorage();
  const {
    usuario,
    getEmpresaSelecionada,
    selecionarEmpresa
  } = useSessaoAtual();
  const [nomeUsuario, setNomeUsuario] = useState(
    usuario?.saudacao || 'Visitante',
  );
  const [empresaAtual, setEmpresaAtual] = useState<string>(
    getEmpresaSelecionada()?.Id || '',
  );
  const [imagemAtual, setImagemAtual] = useState(UsuarioSemImagem);

  const EmpresaListMock = React.useMemo(() => {
    return usuario!.empresa.map((item) => {
      return new KeyValueModel(item.Id, item.Descricao);
    });
  }, [usuario]);

  useEffect(() => {
    let imagem = '';
    try {
      if ((usuario?.imagem || '').indexOf('http') > -1) {
        imagem = usuario?.imagem!;
      } else {
        imagem = (usuario?.imagem || '').length > 0 ? atob(usuario?.imagem || '') : '';
      }
    } catch { }
    setImagemAtual(imagem);
    setNomeUsuario(usuario?.saudacao || 'Visitante');
  }, [usuario]);

  const addDefaultSrc = useCallback((e: any) => {
    setImagemAtual(UsuarioSemImagem);
  }, []);

  const handleEmpresa = React.useCallback(
    async (id: string) => {
      selecionarEmpresa(id);
      setEmpresaAtual(id);
      delRegistro(SngpcStorageKeys.ProcessosSetores, false);
      fecharMenu();
      window.location.reload()
    },
    [delRegistro, fecharMenu, selecionarEmpresa],
  );

  const component = React.useMemo(() => {
    return (
      <>
        <div
          className={classNames(
            classes.drawerResumoPerfilContainer,
            props.modeloAtual === 'Completo' && !props.isMobile
              ? classes.drawerPerfilCompletoNotMobile
              : undefined,
            props.modeloAtual === 'Mini' ? classes.drawerPerfilMini : undefined,
          )}
        >
          <div className="fotoPerfilContainer">
            {imagemAtual !== UsuarioSemImagem && (
              <img src={imagemAtual} onError={addDefaultSrc} alt="" />
            )}
            {imagemAtual === UsuarioSemImagem && (
              <img src={imagemAtual} alt="" />
            )}
          </div>
          <div>
            {props.modeloAtual === 'Completo' && (
              <div className="nomeContainer">
                <div className={classes.containerNomeEPlano}>
                  <Typography className={classes.usuarioNome}>
                    {nomeUsuario}
                  </Typography>
                </div>
              </div>
            )}
            {usuario!.empresa.length > 1 && (
              <Box mt={"4px"}>
                <Grid>
                  <SelectSaurus
                    allowSubmit
                    size="small"
                    conteudo={EmpresaListMock}
                    variant="standard"
                    className={classes.selectEmpresa}
                    onChange={(event) => {
                      if (event) {
                        const newStatus = EmpresaListMock.filter(
                          (item) => item.Key === event.target.value,
                        )[0]?.Key;

                        if (newStatus !== empresaAtual) {
                          confirm({
                            title: 'Selecionar Empresa',
                            description:
                              'Você tem certeza que quer trocar de empresa? Isso irá remover os processos já selecionados!',
                            cancellationText: 'Voltar',
                            cancellationButtonProps: {
                              color: 'default',
                            },
                            confirmationText: 'Selecionar',
                          }).then(() => {
                            return handleEmpresa(newStatus);
                          })
                        }
                      }
                    }}
                    value={empresaAtual}
                  />
                </Grid>
              </Box>
            )}
          </div>
        </div>
      </>
    );
  }, [EmpresaListMock, addDefaultSrc, classes.containerNomeEPlano, classes.drawerPerfilCompletoNotMobile, classes.drawerPerfilMini, classes.drawerResumoPerfilContainer, classes.selectEmpresa, classes.usuarioNome, confirm, empresaAtual, handleEmpresa, imagemAtual, nomeUsuario, props.isMobile, props.modeloAtual, usuario]);

  return component;
};
